import {
  ADMIN_CASH_FLOWS_PATH,
  ADMIN_REFRESH_ACCOUNT_DATA_PATH,
  GET_CASH_FLOW_VERIFICATION_CSV_PATH,
  GET_ALL_USER_ACCOUNTS_PATH,
  GET_ALL_USER_ACCOUNTS_CSV_PATH,
  GET_TOP_USER_ACCOUNTS_PATH,
  SET_EXCLUDED_FROM_TOP_ACCOUNTS_PATH,
  SET_ACCOUNT_CFD_STATUS_PATH,
} from '../../../../constants'
import AbstractService from '../../../../services/AbstractService'

import {
  GetAccountsRequest,
  GetAccountsCSVResponse,
  GetCashFlowVerificationCSVRequest,
  GetCashFlowVerificationCSVResponse,
  GetTopAccountsRequest,
  GetAccountsResponse,
  GetTopAccountsResponse,
  SetExcludedFromTopRequest,
  SetExcludedFromTopResponse,
  SetCfdStatusRequest,
  SetCfdStatusResponse,
  AdminCashFlowBalanceRequest,
  AdminCashFlowBalanceResponse,
  AdminCashFlowsRequest,
  AdminCashFlowsResponse,
  AdminCashFlowStatsRequest,
  AdminCashFlowStatsResponse,
} from './types'

class AccountsApiClass extends AbstractService {
  getAllAccounts = (data: GetAccountsRequest) =>
    this.request<GetAccountsResponse>(GET_ALL_USER_ACCOUNTS_PATH, 'post', false, data)
  getAllAccountsCsv = (data: GetAccountsRequest) =>
    this.getBlobWithFilename<GetAccountsCSVResponse>({
      url: GET_ALL_USER_ACCOUNTS_CSV_PATH,
      method: 'post',
      data,
    })
  getCashFlowVerificationCsv = (data?: GetCashFlowVerificationCSVRequest) =>
    this.getBlobWithFilename<GetCashFlowVerificationCSVResponse>({
      url: GET_CASH_FLOW_VERIFICATION_CSV_PATH,
      method: 'post',
      data,
    })
  getTopAccounts = (data: GetTopAccountsRequest) =>
    this.request<GetTopAccountsResponse>(GET_TOP_USER_ACCOUNTS_PATH, 'post', false, data)

  setExcludedFromTop = (data: SetExcludedFromTopRequest) =>
    this.request<SetExcludedFromTopResponse>(
      SET_EXCLUDED_FROM_TOP_ACCOUNTS_PATH,
      'put',
      false,
      data,
    )

  setCfdStatus = (data: SetCfdStatusRequest) =>
    this.request<SetCfdStatusResponse>(SET_ACCOUNT_CFD_STATUS_PATH, 'put', false, data)

  refreshAccountData = (accountId: number) =>
    this.request(`${ADMIN_REFRESH_ACCOUNT_DATA_PATH}/${accountId}`, 'get', false)

  getAccountCashFlows = (data: AdminCashFlowsRequest) =>
    this.request<AdminCashFlowsResponse>(ADMIN_CASH_FLOWS_PATH, 'post', false, data)

  getAccountCashFlowBalance = (data: AdminCashFlowBalanceRequest) =>
    this.request<AdminCashFlowBalanceResponse>(
      `${ADMIN_CASH_FLOWS_PATH}/balance`,
      'post',
      false,
      data,
    )

  getAccountCashFlowStats = (data: AdminCashFlowStatsRequest) =>
    this.request<AdminCashFlowStatsResponse>(`${ADMIN_CASH_FLOWS_PATH}/stats`, 'post', false, data)
}

export const AccountsApi = new AccountsApiClass()
